import { getSavedViews } from "../../../../../../redux/SingleDataset/selectors";
import { useSelector } from "react-redux";
import styles from "./SaveViewButton.module.scss";
import classNames from "classnames";
import VLTooltip from "views/uikit/VLTooltip";
import { useSearchParams } from "react-router-dom";
import { useMemo } from "react";
import { checkAnyFilterApplied } from "../../../../../../helpers/utility/utilities";
import { SAVED_VIEW_PARAMETER } from "../../../../../../helpers/constants/miscellaneous";
import { SavedViewIcon } from "../../../../../../assets/icons/SavedViewIcon";
import { SaveViewOptions } from "../SaveViewOptions";
import VLPopover from "../../../../../../views/uikit/VLPopover";
import { useVisibility } from "hooks/useVisibility";

const TEXT = "Save view";

export const SaveViewButton = ({
  className,
  iconOnly,
  tooltipText,
  fillEnabled = true,
  onQueryPanel,
}: {
  fillEnabled?: boolean;
  tooltipText?: string;
  iconOnly?: boolean;
  className?: string;
  onQueryPanel?: boolean;
}) => {
  const [searchParams] = useSearchParams();
  const { isOpen, close, toggle } = useVisibility();
  const anyFilterApplied = useMemo(
    () => checkAnyFilterApplied(searchParams),
    [searchParams],
  );
  const selectedViewId = searchParams.get(SAVED_VIEW_PARAMETER);
  const savedViews = useSelector(getSavedViews);
  const selectedSavedView = savedViews.find(
    (view) => view.id === selectedViewId,
  );

  if (!anyFilterApplied && !savedViews.length) {
    return null;
  }

  const triggerContent = iconOnly ? (
    <VLTooltip
      title={tooltipText || selectedSavedView?.name || TEXT}
      forceHide={isOpen}
    >
      <>
        <SavedViewIcon
          filled={fillEnabled && Boolean(selectedSavedView)}
          className={classNames(styles.iconOnly, {
            [styles.filled]: fillEnabled && selectedSavedView,
          })}
        />
      </>
    </VLTooltip>
  ) : (
    <>
      <SavedViewIcon />
      <div>{TEXT}</div>
    </>
  );

  return (
    <VLPopover
      placement="bottomRight"
      trigger="click"
      open={isOpen}
      onOpenChange={toggle}
      arrow={false}
      content={<SaveViewOptions onClose={close} onQueryPanel={onQueryPanel} />}
      overlayClassName={styles.popover}
    >
      <div className={classNames(styles.saveViewButton, className)}>
        {triggerContent}
      </div>
    </VLPopover>
  );
};
